import { defineMessages, useIntl } from 'react-intl';
import { useEffect, useState } from 'react';

import { SelectInput } from '@arpav/components';

const messages = defineMessages({
  emaillabel: {
    id: 'Indirizzo email a cui inviare i dati *',
    defaultMessage: 'Indirizzo email a cui inviare i dati *',
  },
  invalidEmail: {
    id: '* Indirizzo email valido',
    defaulMessage: '* Indirizzo email valido',
  },
  selectOption: {
    id: 'Selezionare una voce',
    defaultMessage: 'Selezionare una voce',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
});

const SourceField = ({ formData, setFormData, filter, error, setError }) => {
  const intl = useIntl();
  const [sourceOptions, setSourceOptions] = useState();
  const [formSrcOptions, setFormSrcOptions] = useState();
  const [selectedValue, setSelectedValue] = useState();

  const apiBaseUrl = `https://api.arpa.veneto.it/REST/v1/`;

  /**
   * format source options
   */
  useEffect(() => {
    if (sourceOptions?.length > 0) {
      const mappedArray = sourceOptions?.map(option => {
        const value = option?.[filter?.sourcepropVal] ?? '';
        const label = option?.[filter?.sourcepropLab] ?? '';
        return { value, label, name: label };
      });
      const optionsWithDefault = [
        {
          value: '',
          label: intl.formatMessage(messages.selectOption),
          name: intl.formatMessage(messages.selectOption),
        },
        ...mappedArray,
      ];

      setFormSrcOptions(optionsWithDefault);
    } else {
      setFormSrcOptions([
        {
          value: '',
          label: intl.formatMessage(messages.selectOption),
          name: intl.formatMessage(messages.selectOption),
        },
      ]);
    }
  }, [sourceOptions]);

  useEffect(() => {
    try {
      fetch(`${apiBaseUrl}${filter?.source}`)
        .then(res => res.json())
        .then(result => {
          const propertyField = filter.filterBy || null;
          if (formData[propertyField]) {
            const filteredData = result?.data?.filter(
              item => item[filter?.filterProp] === formData[propertyField]
            );
            setSourceOptions(filteredData || []);
          } else if (result?.data?.length > 0) {
            setSourceOptions(result?.data);
          } else {
            setSourceOptions([]);
          }
          setSelectedValue();
        });
    } catch (e) {
      console.error(e);
    }
  }, [formData[filter.filterBy], filter, apiBaseUrl]);

  /**
   * Source filter validator
   */
  const sourceValidator = selectedOption => {
    if (selectedOption?.name) {
      setFormData(formData => ({
        ...formData,
        [filter?.propertyField]: selectedOption?.value,
      }));
      setSelectedValue(selectedOption);
      if (filter?.mandatory && !selectedOption?.value) {
        setError(prev => ({
          ...prev,
          [filter?.propertyField]: intl.formatMessage(messages.requiredField),
        }));
      } else {
        setError(prev => ({
          ...prev,
          [filter?.propertyField]: '',
        }));
      }
    }
  };

  return (
    <>
      <SelectInput
        id={filter?.propertyField || filter?.labelField}
        name={filter?.propertyField || filter?.labelField}
        label={
          filter?.mandatory
            ? `${filter?.labelField || filter?.propertyField} * `
            : filter?.labelField || filter?.propertyField
        }
        onChange={sourceValidator}
        options={formSrcOptions}
        value={selectedValue}
        required={filter?.mandatory}
      />
      {error && (
        <label color="danger" htmlFor="startDate-field" className="mt-0 text-danger lh-1 word-wrap">
          <small>{error}</small>
        </label>
      )}
    </>
  );
};

export default SourceField;
